import { ECoordinatorSessionStatus, TAppointmentCamel } from '@/types';

const OPEN_REQUEST_STATUSES: ECoordinatorSessionStatus[] = [
  ECoordinatorSessionStatus.TO_BE_CONFIRMED,
  ECoordinatorSessionStatus.NO_ANSWER,
  ECoordinatorSessionStatus.TO_BE_RESCHEDULED,
  ECoordinatorSessionStatus.TO_BE_CANCELLED,
];

/**
 * Returns true if the latest coordinator status requires action (open request state).
 * Returns false when `outreachStatus` is not set or empty.
 * @param outreachStatus - The appointment's coordinator status history.
 * @returns True if the latest coordinator status is an open request status.
 */
export const isOpenRequest = (
  outreachStatus: TAppointmentCamel['outreachStatus'],
): boolean => {
  const latest = outreachStatus?.at(-1)?.action;
  if (!latest) return false;
  return OPEN_REQUEST_STATUSES.includes(latest);
};
